import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRevert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 10C17.5 14.1422 14.1422 17.5 10 17.5C8.07912 17.5 6.32689 16.7778 5 15.5902L2.5 13.3333M2.5 13.3333V17.5M2.5 13.3333H6.66667M2.5 10C2.5 5.85787 5.85787 2.5 10 2.5C11.9209 2.5 13.6731 3.22213 15 4.40973L17.5 6.66667M17.5 6.66667V2.5M17.5 6.66667H13.3333",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRevert;
